var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.749a1 1 0 10-2 0v.774L3.846 8.384a.5.5 0 00-.346.476v5.957a.5.5 0 00.35.477l1.3.408a.5.5 0 01.35.477v2.591a4.505 4.505 0 004.5 4.48h.021a4.505 4.505 0 004.479-4.517v-.1l7.5 2.35v.766a1 1 0 002 0zM12.5 18.738a2.5 2.5 0 01-2.488 2.512H10a2.5 2.5 0 01-2.5-2.484v-1.647a.5.5 0 01.65-.477l4 1.254a.5.5 0 01.35.477zM2 8.249a1 1 0 00-1-1 1 1 0 00-1 1l.005 7a1 1 0 001 1H1a1 1 0 001-.976z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.906d4b49.svg";
export { ForwardRef as ReactComponent };